import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import { useAppDependencyGraphProvider } from '../../../../context/DependencyGraphProvider';
import { useGlobalAppStateStore } from '../../../../stores/app/GlobalAppStateStore';
import { ComputeContextKeys } from '../../../computeContext/const';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

function useSetInterfaceSessionStorage() {
  const { setSessionStorage } = useGlobalAppStateStore().hooks.useActions();
  const {
    actions: { notifyDependencyChange },
  } = useAppDependencyGraphProvider();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const onSetInterfaceSessionStorage: ActionHandlerType = ({
    action,
    actionContext,
  }: OnActionArgs) => {
    const { payload } = action;

    const { value: computedPayload } = getNoCodeComputedData<{
      value: {
        operation: 'SET_IN' | 'REMOVE' | 'CLEAR';
        path?: string;
        value?: unknown;
      };
    }>(
      {
        value: payload,
      },
      actionContext,
    );

    if (computedPayload.operation === 'SET_IN' || computedPayload.operation === 'REMOVE') {
      if (!computedPayload.path) {
        console.error('path is required in SET_IN');
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      }
      setSessionStorage({
        operation: computedPayload.operation,
        payload: {
          path: computedPayload.path,
          value: computedPayload.value,
        },
      });
    } else if (computedPayload.operation === 'CLEAR') {
      setSessionStorage({
        operation: computedPayload.operation,
        payload: {},
      });
    }

    notifyDependencyChange({ id: ComputeContextKeys.SESSION_STORAGE });
    notifyDependencyChange({ id: ComputeContextKeys.DEPRECATED_SESSION_STORAGE });

    return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
  };

  return { onSetInterfaceSessionStorage };
}

export default useSetInterfaceSessionStorage;
